// extracted by mini-css-extract-plugin
export default {"mainContentContainer":"MainContent_mainContentContainer__vMtC1"};